import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, startWith, Subject, switchMap, tap } from 'rxjs';
import { ProcessService } from '../../services/process.service';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-affiliate-links-info',
  templateUrl: './affiliate-links-info.component.html',
})
export class AffiliateLinksInfoComponent {
  readonly marketingAssetsFileName = 'Ulotki.zip';
  readonly affiliateLink = 'https://www.allianz.pl/pl_PL/kalkulator-ubezpieczenia-turystycznego.html?affiliateNumber=';
  agentNumber$!: Observable<string | undefined>;
  downloadMarketingAssets$ = new Subject<void>();
  isDownloadAssetsLoaderShown = new Subject<boolean>();

  constructor(public processService: ProcessService, private apiService: ApiService) {
    this.agentNumber$ = this.processService.agentNumberFromToken$.pipe(startWith(this.processService.preserveAgentNumber));

    this.downloadMarketingAssets$
      .pipe(
        takeUntilDestroyed(),
        tap(() => this.isDownloadAssetsLoaderShown.next(true)),
        switchMap(() => this.apiService.getMarketingAssets()),
        tap((resp) => {
          const downloadURL = window.URL.createObjectURL(resp.body as Blob);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = this.marketingAssetsFileName;
          link.click();
          this.isDownloadAssetsLoaderShown.next(false);
        }),
      )
      .subscribe();
  }
}
